import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
export function useIsCheckoutRoute() {
  const $ = _c(2);
  const t0 = usePathname();
  let t1;
  if ($[0] !== t0) {
    t1 = t0.startsWith("/store/checkout/");
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}